import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=012c77d9&scoped=true&lang=scss"

import exportComponent from "/Users/chenlin/Desktop/WORK/ideaWork/信访/mailbox-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012c77d9"]])

export default __exports__